import React, {useRef} from 'react';
import {Button, Col, Container, Row} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faArrowLeftLong,
    faCircle,
    faClock,
    faDatabase, faDiagramProject,
    faFileCircleCheck,
    faRefresh,
    faUser
} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";
import moment from "moment/moment";
import {toast} from "react-toastify";
import ApiService from "../../api/ApiService";
import {formatBeijingTime} from "../../api/TimeService";
import {copyToClipboard} from "../../utils/clipboardUtils";
import AgentConsumptionInfoModal from "../../components/AgentConsumptionInfoModal";


const WorkFlowExecuteRecordList = () => {
    const navigate = useNavigate();
    const [data, setData] = React.useState([]);
    // const [currentPage, setCurrentPage] = React.useState(1);
    const currentPageRef = useRef(1); // 添加ref来同步跟踪当前页码
    const [hasMoreData, setHasMoreData] = React.useState(true); // 新增状态：是否有更多数据
    const [isFetching, setIsFetching] = React.useState(false); // 新增状态：是否正在获取数据

    const [agentConsumptionInfoVisible, setAgentConsumptionInfoVisible] = React.useState(false); // 新增状态：是否正在获取数据
    const [curAgentConsumptionInfo, setCurAgentConsumptionInfo] = React.useState([]); // 新增状态：是否正在获取数据
    const api =new ApiService();
    // 模拟数据请求函数
    const fetchMoreData = async () => {
        if (!hasMoreData || isFetching) return; // 如果没有更多数据或正在获取数据，直接返回

        setIsFetching(true); // 设置为正在获取数据

        const result = await api.executeWorkflowResultList(10, currentPageRef.current);
        const newData =result.data

        // // 假设每次加载10条新数据
        // const newData = Array.from({length: 10}, (_, index) => ({
        //     id: 2102,
        //     user_id: 315608,
        //     token: "",
        //     workflow_id: "7490463549186539531",
        //     bot_id: null,
        //     parameters: "{\"bgm\":\"治愈\",\"sound\":\"雷电\"}",
        //     app_id: null,
        //     outputs: "{\"node_status\": \"{}\", \"Output\": \"{\\\"output\\\":\\\"\\u6cbb\\u6108\\\"}\"}",
        //     debug_url: "https://www.coze.cn/work_flow?execute_id=7522751718430392346&space_id=7395390088370880563&workflow_id=7490463549186539531&execute_mode=2",
        //     execute_id: "7522751718430392346",
        //     status: 2,
        //     money: 10,
        //     time: "2025-07-03T15:18:46",
        //     update_time: "2025-07-03T15:18:46"
        // }));
        setData(prevData => [...prevData, ...newData]);
        currentPageRef.current = currentPageRef.current + 1; // 同步更新ref
        setIsFetching(false); // 重置为未获取数据状态
        if (newData.length < 10) {
            setHasMoreData(false);
        }

    };

    // 使用 Intersection Observer 监听元素是否进入视口
    const observer = React.useRef();
    const lastElementRef = React.useCallback(node => {
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMoreData && !isFetching) { // 只有在还有更多数据且未获取数据时才触发加载
                fetchMoreData();
            }
        });
        if (node) observer.current.observe(node);
    }, [hasMoreData, isFetching]);
    const refreshList=() => {
        setData([]);
        currentPageRef.current = 1;
        setHasMoreData(true);
        fetchMoreData();
    }
    function extractUrlFromString(str) {
        const urlRegex = /(https?:\/\/[^\s]+)/;
        const match = str?.match(urlRegex);
        return match ? match[1] : '';
    }

    async function executeVideoGen(flowTaskId) {
        const result = await api.executeWorkflowVideoGen(flowTaskId);
        if (result.code === 200) {
            toast.success(`提交成功`);
            refreshList();
        } else {
            toast.error(`执行失败: ${result.msg}`);
        }
    }
    function isDraftUrl(item) {
        //如果url格式不是该https://[\w.-]+/JianYingAssistant?draftId=1955910676335157248就不显示云渲染按钮
        try {
            const result = JSON.parse(JSON.parse(item.outputs)?.Output)?.data;
            const url = extractUrlFromString(result);
            // 使用正则表达式验证URL格式是否为 https://[\w.-]+/JianYingAssistant?draftId=数字
            const urlPattern = /^https:\/\/[\w.-]+\/JianYingAssistant\?draftId=\d+$/;
            return urlPattern.test(url);
        } catch (e) {
            return false;
        }
    }
    return (
        <Container>
            <div className={'pb-3'}>
                <div style={{alignItems: 'start', display: 'flex',}}>
                    <button style={{
                        color: '#101217',
                        border: 'none',
                        background: '#02C8E3',
                        borderRadius: '12px',
                        padding: '6px 22px',
                    }} onClick={() => {
                        navigate(-1)
                    }}>
                        <span style={{marginRight: '10px'}}>
                        <FontAwesomeIcon icon={faArrowLeftLong} color={'#101217'} size={'1x'}/>
                      </span>
                        返回
                    </button>
                </div>
                <div style={{background: '#15191E', padding: '24px', borderRadius: '20px',}}>
                    <div className={'mb-3 d-flex justify-content-between'} style={{background: '#2C2F37',padding: '20px',}}>
                        <div style={{color: '#02C8E3', textAlign: 'start',fontSize: '22px',}}>
                            工作流执行记录<span style={{display: 'inline-block',color: '#ffffff', fontSize: '12px',}}>(有效期7天，请尽快下载)</span>
                        </div>

                        <Button
                            onClick={() => {refreshList()}}
                            style={{background: 'transparent',color: '#02C8E3',marginRight: '10px',borderColor: '#02C8E3',borderRadius: '8px',}} size={'sm'}>
                            <FontAwesomeIcon icon={faRefresh} color={'#02C8E3'} size={'1x'} style={{marginRight: '4px'}}/>
                            刷新
                        </Button>
                    </div>

                    {data?.map((item, index) => (
                        <div key={index} style={{
                            position: 'relative',
                            marginBottom: '20px',
                            padding: '16px',
                            borderRadius: '8px',
                            overflowWrap: 'anywhere'
                        }}> {/*1成功 -1失败 2执行中 0等待执行 */}
                            <span className={'badge rounded-pill'} style={{
                                background: '#242836',
                                position: 'absolute',
                                fontSize: '14px',
                                color: item.status === 1 ? '#04D7F3' :(item.status === -1 ?  '#DE4444':'#f4f238'),
                                top: '5px',
                                right: '5px',
                            }}><FontAwesomeIcon icon={faCircle}
                                                width={'6px'}/> {item.status === 1 ? '执行成功' :(item.status === -1 ? '执行失败':'执行中') }</span>
                            <div className={'mb-3'} style={{
                                color: '#B4BFC5',
                                fontSize: '16px',
                                textAlign: 'start',
                            }}>{item?.flow?.title}</div>
                            <div className={'mb-3'} style={{
                                color: '#B4BFC5',
                                fontSize: '14px',
                                paddingLeft: '5px',
                                paddingRight: '5px',
                                textAlign: 'start',
                            }}><FontAwesomeIcon icon={faUser} color={'#02C8E3'}/> 记录ID:{item.id}</div>
                            <Row style={{textAlign: 'start'}}>
                                <Col md={6}>
                                    <div className={'mb-3'} style={{
                                        color: '#B4BFC5',
                                        fontSize: '14px',
                                        paddingLeft: '5px',
                                        paddingRight: '5px',
                                        textAlign: 'start',
                                    }}><FontAwesomeIcon icon={faDatabase} color={'#02C8E3'}/> 消费金额:￥{item.cost/100}
                                        <Button size={'sm'} style={{
                                            color: '#02C8E3',
                                            border: '1px solid #02C8E3',
                                            background: 'none',
                                            flexShrink: 0,
                                            borderRadius: '4px',
                                            padding: '2px 11px',
                                            marginLeft: '10px',
                                        }} onClick={() => {
                                            if (!item.pointRecords) {
                                                toast.info("暂时无明细");
                                                return
                                            }
                                            setCurAgentConsumptionInfo(item.pointRecords)
                                            setAgentConsumptionInfoVisible(true)
                                        }}>查看明细
                                        </Button>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className={'mb-3'} style={{
                                        color: '#B4BFC5',
                                        fontSize: '14px',
                                        paddingLeft: '5px',
                                        paddingRight: '5px',
                                        textAlign: 'start',
                                    }}><FontAwesomeIcon icon={faClock}
                                                        color={'#02C8E3'}/> 执行时间:{formatBeijingTime(item.created)}
                                    </div>
                                </Col>
                            </Row>

                            <div className={'mb-3'} style={{
                                color: '#B4BFC5',
                                fontSize: '14px',
                                paddingLeft: '5px',
                                paddingRight: '5px',
                                display: 'flex',
                                justifyContent: 'start',
                            }}><span  style={{
                                textAlign: 'start',
                                lineHeight: '2',
                                display: '-webkit-box',
                                WebkitBoxOrient: 'vertical',
                                WebkitLineClamp: 1, overflow: 'hidden',
                                overflowWrap: 'anywhere'
                            }}>
                                <FontAwesomeIcon icon={faFileCircleCheck}
                                                color={'#02C8E3'}/> 执行结果: {item.outputs&& extractUrlFromString(JSON.parse(JSON.parse(item.outputs)?.Output)?.data)}</span>
                                {item.outputs ? (
                                    <>
                                        <Button size={'sm'} style={{
                                            color: '#02C8E3',
                                            border: '1px solid #02C8E3',
                                            background: 'none',
                                            flexShrink: 0,
                                            borderRadius: '4px',
                                            padding: '2px 11px',
                                            marginLeft: '10px',
                                        }} onClick={() => {
                                            if (item.outputs){
                                                const result = JSON.parse(JSON.parse(item.outputs)?.Output)?.data;
                                                const url = extractUrlFromString(result);
                                                copyToClipboard(url)
                                            }
                                        }}>复制
                                        </Button>
                                        {item.cloud == null && isDraftUrl(item)&& (<Button size={'sm'} style={{
                                            color: '#02C8E3',
                                            border: '1px solid #02C8E3',
                                            background: 'none',
                                            flexShrink: 0,
                                            borderRadius: '4px',
                                            padding: '2px 11px',
                                            marginLeft: '10px',
                                        }} onClick={() => {
                                            executeVideoGen(item.id)
                                        }}>云渲染
                                        </Button>)}

                                    </>
                                ):(
                                    <span style={{alignContent: 'center',marginLeft: '8px'}}>{item.status === -1 ? '执行失败':'任务执行中，请稍后...'}</span>
                                    )}

                            </div>
                            {item.cloud&&
                                <>
                                    <Row style={{textAlign: 'start'}}>
                                        <Col md={6}>
                                            <div className={'mb-3'} style={{
                                                color: '#B4BFC5',
                                                fontSize: '14px',
                                                paddingLeft: '5px',
                                                paddingRight: '5px',
                                                textAlign: 'start',
                                            }}><FontAwesomeIcon icon={faClock}
                                                                color={'#02C8E3'}/> 云渲染执行时间:{formatBeijingTime(item.cloud?.created)}
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className={'mb-3'} style={{
                                                color: '#B4BFC5',
                                                fontSize: '14px',
                                                paddingLeft: '5px',
                                                paddingRight: '5px',
                                                textAlign: 'start',
                                            }}><FontAwesomeIcon icon={faDiagramProject} color={'#02C8E3'}/> 云渲染执行状态:
                                                <span className={'badge rounded-pill'} style={{
                                                    background: '#242836',
                                                    fontSize: '14px',
                                                    marginLeft: '5px',
                                                    color: item.status === 1 ? '#04D7F3' :(item.status === -1 ?  '#DE4444':'#f4f238'),
                                                    top: '5px',
                                                    right: '5px',
                                                }}>{item.cloud?.status === 1 ? '执行成功' :(item.cloud?.status === -1 ? '执行失败':'执行中')}
                                                </span>
                                                </div>
                                        </Col>
                                    </Row>
                                    <div className={'mb-3'} style={{
                                        color: '#B4BFC5',
                                        fontSize: '14px',
                                        paddingLeft: '5px',
                                        paddingRight: '5px',
                                        display: 'flex',
                                        justifyContent: 'start',
                                    }}><span  style={{
                                        textAlign: 'start',
                                        lineHeight: '2',
                                        display: '-webkit-box',
                                        WebkitBoxOrient: 'vertical',
                                        WebkitLineClamp: 1, overflow: 'hidden',
                                        overflowWrap: 'anywhere'
                                    }}>
                                <FontAwesomeIcon icon={faFileCircleCheck}
                                                 color={'#02C8E3'}/> 云渲染结果: {item.cloud?.result}</span>
                                        {item.cloud?.status===1 ? (
                                            <>
                                                <Button size={'sm'} style={{
                                                    color: '#02C8E3',
                                                    border: '1px solid #02C8E3',
                                                    background: 'none',
                                                    flexShrink: 0,
                                                    borderRadius: '4px',
                                                    padding: '2px 11px',
                                                    marginLeft: '10px',
                                                }} onClick={() => {
                                                    if (item.cloud){
                                                        const result = item.cloud?.result;
                                                        // copyToClipboard('outputs',result);
                                                        // 在新窗口中打开链接
                                                        window.open(result, '_blank');
                                                    }
                                                }}>下载
                                                </Button>
                                            </>
                                        ):(
                                            <span style={{alignContent: 'center',marginLeft: '8px'}}>{item.cloud?.status === -1 ? '云渲染执行失败':'云渲染执行中，请稍后...'}</span>
                                        )}

                                    </div>
                                </>

                            }

                        </div>
                    ))}
                    {/* 观察目标元素 */}
                    {hasMoreData ? (
                        <div ref={lastElementRef}
                             style={{textAlign: 'center', marginTop: '20px', color: 'white'}}>加载更多...</div>
                    ) : (
                        <div style={{textAlign: 'center', marginTop: '20px', color: 'white'}}>没有更多数据了</div>
                    )}
                </div>
            </div>
            <AgentConsumptionInfoModal visible={agentConsumptionInfoVisible} agentConsumptionInfo={curAgentConsumptionInfo}  onClose={() => setAgentConsumptionInfoVisible(false)}/>

        </Container>

    );
};

export default WorkFlowExecuteRecordList;